document.addEventListener('DOMContentLoaded', () => {

  const mainProductName = document.querySelector('[data-product-name]').getAttribute('data-product-name');

  const checkboxes = document.querySelectorAll('[data-main-checkbox]');
  const productSlider = document.querySelector('[data-product-media-wrapper]');
  const formatDownforce = (downforce) => {
    return `+ ${downforce.toLocaleString('en-US')}kg`;
  };

  const calculateTotalPrice = () => {
    let mainProductPrice = document.querySelector('[data-total-price]');
    let mainProductPriceValue = mainProductPrice.getAttribute('data-total-price');
    mainProductPriceValue = parseFloat(mainProductPriceValue.replace(/[^0-9.]/g, '')) || 0;

    let totalPrice = mainProductPriceValue;
    let totalDownforce = 0;

    const extractPrice = (element) => {
      if (!element) return 0;
      const priceText = element.textContent.replace(/[^0-9.]/g, '');
      return parseFloat(priceText) || 0;
    };

    const sumPricesAndDownforce = (selector, parentSelector) => {
      document.querySelectorAll(selector).forEach((input) => {
        const parent = input.closest(parentSelector);
        if (parent) {
          // Sum prices
          const priceElement = parent.querySelector('[data-price]');
          totalPrice += extractPrice(priceElement);

          // Sum downforce values
          const downforceValue = parseFloat(input.getAttribute('data-downforce')) || 0;
          totalDownforce += downforceValue;
        }
      });
    };

    // Sum prices and downforce for selected product radios
    sumPricesAndDownforce('[data-radio="product-radio"]:checked', '[data-radio="product-radio-label"]');

    // Sum prices and downforce for checked addon checkboxes
    sumPricesAndDownforce('[data-checkbox="addon-product-checkbox"]:checked', '[data-checkbox="addon-product-checkbox-label"]');

    // Update the total downforce in the DOM
    const totalDownforceElement = document.querySelector('[data-total-downforce]');
    if (totalDownforceElement) {
      if (totalDownforce > 0) {
        totalDownforceElement.textContent = formatDownforce(totalDownforce);
        totalDownforceElement.parentElement.removeAttribute('hidden');
      } else {
        totalDownforceElement.parentElement.setAttribute('hidden', 'true');
      }
    } else {
      totalDownforceElement.parentElement.setAttribute('hidden', 'true');
      console.error('Total downforce element not found.');
    }

    // Ensure price has 2 decimal places
    const formattedTotalPrice = parseFloat(totalPrice).toFixed(2);

    // Update the total price in the DOM
    const totalPriceElement = document.querySelector('[data-total-price] .price-item--regular');
    if (totalPriceElement) {
      totalPriceElement.textContent = theme.Shopify.formatMoney(formattedTotalPrice, theme.money_format);
    } else {
      console.error('Total price element not found.');
    }
  };

  const createHiddenInputForCheckedRadio = () => {
    const productForm = document.querySelector('[data-add-on-products-list]');

    if (!productForm) {
      console.error('Product form not found.');
      return;
    }

    // Helper function to create and append a hidden input
    const createHiddenInput = (variantId, type, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `items[${variantId}][${type}]`;
      input.value = value;
      input.setAttribute('data-main-product', 'false');
      if (type === 'properties[_product-type]') input.setAttribute('data-child-product', 'true');
      if (type === 'properties[_parent-product]') input.setAttribute('data-parent-product', mainProductName);
      input.classList.add('product-variant-id');
      productForm.appendChild(input);
    };

    // Remove all existing removable hidden inputs
    const existingInputs = productForm.querySelectorAll('input[data-main-product="false"]');
    existingInputs.forEach((input) => input.remove());

    // Process checked inputs (radios and checkboxes)
    const processCheckedInputs = (selector, type) => {
      document.querySelectorAll(selector).forEach((input) => {
        const variantId = input.value; // Cache value
        createHiddenInput(variantId, 'id', variantId);
        createHiddenInput(variantId, 'quantity', 1);
        createHiddenInput(variantId, 'properties[_product-type]', type);
        createHiddenInput(variantId, 'properties[_parent-product]', mainProductName);
      });
    };

    // Process radio and checkbox inputs
    processCheckedInputs('[data-radio=product-radio]:checked', 'child-product');
    processCheckedInputs('[data-checkbox=addon-product-checkbox]:checked', 'addon-product');
  };

  const createImage = (productImage) => {
    document.querySelector('.selected-product-image-container')?.remove();

    const container = document.createElement('div');
    container.className = 'selected-product-image-container';

    const img = document.createElement('img');
    Object.assign(img, {
      src: productImage.getAttribute('data-product-image'),
      alt: productImage.alt || 'Selected product',
      className: 'selected-product-image'
    });

    const closeButton = document.createElement('button');
    closeButton.className = 'selected-product-image-close-button';
    closeButton.onclick = () => {
      container.classList.add('fade-out');
      setTimeout(() => {
        container.remove();
      }, 1000);
    };

    container.append(img, closeButton);
    productSlider.appendChild(container);

    container.autoRemoveTimeout = setTimeout(() => {
      container.classList.add('fade-out');
      setTimeout(() => {
        container.remove();
      }, 1000);
    }, 3000);
  };

  const removeImage = () => {
    document.querySelector('.selected-product-image-container')?.remove();
  };

  const initializeCheckbox = (checkbox) => {
    const parent = checkbox.closest('[data-product-picker-item=product-item]');
    const radioParents = Array.from(parent.querySelectorAll('[data-radio=product-radio-label]'));
    const addonCheckboxeParents = Array.from(parent.querySelectorAll('[data-checkbox=addon-product-checkbox-label]'));

    const updateRadiosState = () => {
      const isChecked = checkbox.checked;

      radioParents.forEach((radioParent, index) => {
        const radioElem = radioParent.querySelector('[data-radio=product-radio]');
        if (radioElem) {
          if (isChecked) {
            radioParent.classList.remove('product__picker-product--disabled');
            radioElem.disabled = false;
            if (index === 0) {
              radioElem.checked = true;
              radioParent.classList.add('product__picker-product--active');
            } else {
              radioParent.classList.remove('product__picker-product--active');
            }
          } else {
            radioParent.classList.add('product__picker-product--disabled');
            radioElem.disabled = true;
            radioElem.checked = false;
            radioParent.classList.remove('product__picker-product--active');
          }
        }
      });

      addonCheckboxeParents.forEach((addonCheckboxParent, index) => {
        const checkboxElem = addonCheckboxParent.querySelector('[data-checkbox=addon-product-checkbox');
        if (checkboxElem) {
          if (isChecked) {
            addonCheckboxParent.classList.remove('product__picker-product--disabled');
            checkboxElem.disabled = false;
            addonCheckboxParent.classList.remove('product__picker-product--active');
          } else {
            addonCheckboxParent.classList.add('product__picker-product--disabled');
            checkboxElem.disabled = true;
            checkboxElem.checked = false;
            addonCheckboxParent.classList.remove('product__picker-product--active');
          }
        }
      });

      calculateTotalPrice();
      createHiddenInputForCheckedRadio();
    };

    checkbox.addEventListener('change', updateRadiosState);

    radioParents.forEach((radioParent) => {
      const radioElem = radioParent.querySelector('[data-radio=product-radio]');
      if (radioElem) {
        radioElem.addEventListener('change', () => {
          if (checkbox.checked) {
            radioParents.forEach((rp) => rp.classList.remove('product__picker-product--active'));
            radioParent.classList.add('product__picker-product--active');
            calculateTotalPrice();
            createImage(productImage);
            createHiddenInputForCheckedRadio();
          }
        });
      }
    });

    addonCheckboxeParents.forEach(checkboxParent => {
      const checkboxElem = checkboxParent.querySelector('[data-checkbox=addon-product-checkbox]');
      const productImage = checkboxParent.querySelector('[data-product-image]');

      checkboxElem?.addEventListener('change', () => {
        checkboxParent.classList.toggle('product__picker-product--active', checkbox.checked && checkboxElem.checked);
        if (checkbox.checked && checkboxElem.checked) createImage(productImage);
        else removeImage();
        calculateTotalPrice();
        createHiddenInputForCheckedRadio();
      });
    });

    // Initialize the state on load
    updateRadiosState();
  };

  checkboxes.forEach(initializeCheckbox);

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-main-checkbox]').forEach(initializeCheckbox);
  });
});
